import { useQuery } from "@tanstack/vue-query";
import { statementCreditsQuery } from "@vendata/power-up-sdk/requests/credits/statement";

export function useCreditStatementLoader() {
  return {
    statementQuery: useQuery(statementCreditsQuery()),
  };
}
